<template>
<section id="changePassword">
  <div v-if="userData">
    <p v-html="message" class="message"></p>
    <table id="formulaire">
      <tr>
        <td><label for="password">{{$t("message['Mot de passe']")}} : </label></td>
        <td><input type="password" id="password" minlength="8" v-model="password" /></td>
      </tr>

      <tr v-if="passwordDontMatch">
        <td colspan="2"><div class="errorPassword" v-if="passwordDontMatch">{{$t("message['Format du mot de passe incorrect']")}}</div></td>
      </tr>

      <tr>
        <td><label for="passwordVerif">{{$t("message['Confirmez mot de passe']")}} : </label></td>
        <td><input type="password" id="passwordVerif" minlength="8" v-model="passwordVerif"/></td>
      </tr>

      <tr v-if="!samePassword">
        <td colspan="2"><div class="errorPassword" v-if="!samePassword">{{$t("message['Le mot de passe et sa confirmation doivent être identiques']")}}</div></td>
      </tr>

      <tr>
        <td colspan="2" class="boutonValider"><button @click="changePassword">{{$t("message['Valider']")}}</button></td>
      </tr>
    </table>
  </div>

  <div v-else class="feedback">
    <p class="error" v-html="$t('message[\'Lien expiré\']')" v-if="lienExpire"></p>
    <p class="success" v-html="$t('message[\'Mot de passe mis à jour\']')" v-else-if="passwordUpdated" ></p>
  </div>
</section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ChangePassword',
  data() {
    return {
      password: null,
      passwordVerif: null,
      userData: null,
      samePassword: true,
      passwordDontMatch: false,
      lienExpire: false,
      passwordUpdated: false
    }
  },

  computed: {
    message() {
      return this.$t("message['Choisissez un nouveau mot de passe']").replace('{0}', '<strong>' + this.userData.login + '</strong>')
    }
  },

  mounted() {
    axios.get('/api/v1/utilisateurs/userdatafrompasswordrecovery?demande_mdp=' + this.$route.query.passwordRecovery).then((response) => {
      if (response.data) {
        let data = response.data
        if ((new Date(data.expiration_mdp)) < Date.now()) { // Si le lien a expiré (> 24h après sa génération)
          this.lienExpire = true
        } else {
          this.userData = data
        }
      } else { // Le code passé en paramètre n'appartient à aucun utilisateur -> on redirige vers la page d'accueil
        window.location.href = window.location.href.substring(0, window.location.href.indexOf('/?passwordRecovery='))
        document.location.reload(true)
      }
    })
      .catch((error) => {
        console.debug('userdatafrompasswordrecovery', error)
      })
  },

  methods: {
    changePassword() {
      if (this.password === this.passwordVerif) { // Les deux mdp sont identiques
        this.samePassword = true
        const options = {
          url: '/api/v1/utilisateurs/changepassword',
          method: 'PUT',
          headers: {
            'code': this.userData.demande_mdp,
            'pwd': this.password
          }
        }

        var self = this
        axios(options).then(response => { // Vérification côté serveur si le mdp respecte les critères de sécurité
          if (response.status === 200) { // Mise à jour du mdp effectuée -> on retire le formulaire de l'affichage
            this.passwordDontMatch = false
            this.userData = null
            this.passwordUpdated = true
          }
        }).catch(function(error) {
          self.passwordDontMatch = true
          console.error('password', error)
        })
      } else {
        this.samePassword = false
      }
    }
  }
}
</script>

<style scoped>
section {
  background-color: white;
  color: black;
}

.message {
    font-size: 16px;
    padding-top: 25px;
    margin-bottom: 15px;
    margin-top: 0;
    text-align: center;
}

table {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.boutonValider button {
  margin-top: 15px;
  margin-bottom: 25px;
}
table td:first-child:not(.boutonValider){
  text-align: right;
}

.errorPassword {
  font-size: 10px;
  color: red;
}

.feedback {
  font-size: 20px;
  text-align: center;
  padding-top: 80px;
  padding-bottom: 80px;
}

.success {
  color: #5cb85c;
}

.error {
  color: #d9534f;
}

</style>
